/*
 * @Author: Teemo Ding
 * @Date: 2022-03-03 11:04:56
 * @LastEditTime: 2022-12-20 16:08:06
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/Template/index.tsx
 */
import CommonHeader from '@/src/components/CommonHeader';
import ModalHOC from '@/src/constrains/ModalHOC';
import useBreadCrumbData from '@/src/pages/SalesCannelVersion/Hooks/useBreadCrumbData';
import {
  getMpTemplates,
  getTemplateDetail,
  saveTemplate,
  sendMessage,
} from '@/src/request/salesChannel/setting/communication';
import { useRequest } from 'ahooks';
import { Form, Spin, message } from 'antd';
import { get } from 'lodash';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  getAllLanguage, //getAreaCodeAll
} from 'src/request/common';
import { i18nGet } from 'src/tools/tools';
import { CommunicationChannelType } from 'src/types/common/communication';
import SendTestModal from '../Components/SendTestModal';
import styles from '../css.module.less';
import CommonTemplate from './CommonTemplate';
import MiniProgramSubscribeMessage from './MiniProgramSubscribeMessage';
import OrderPaymentReminder from './OrderPaymentReminder';
import SMSLocalisedRouting from './SMSLocalisedRouting';
import { conditionsAll } from './config';
import { getAreaCodes } from 'src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
const Template = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { modalOp } = props;
  const { setShowModal, setModalTitle, setModalContent } = modalOp;
  const { loading: breadCrumbLoading, breadcrumbData } = useBreadCrumbData({
    lastSecond: getI18n('general.sider.settings'),
    lastOne: getI18n('salesChannelSettings.config.communication'),
  });
  const [form] = Form.useForm();
  const params: any = useParams();
  const history = useHistory();
  const [hasModified, setHasModified] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const { uuid: salesChannelUuid, communicationUuid, category } = params;
  //const [loading, setLoading] = useState(false);
  const { data: mpTemplates = [] as any } = useRequest(
    () => getMpTemplates(salesChannelUuid),
    {
      onSuccess: () => {
        _getTemplateDetail();
      },
    },
  );
  const { data: languages = [] } = useRequest(() => getAllLanguage());
  const areaCodes = useSelector(getAreaCodes());

  const {
    data: {
      templateSetting: { channelSettings = [], periodUnit } = {} as any,
      templates = [],
      timezoneGmt = '',
    } = {} as any,
    loading: dataLoading,
    run: _getTemplateDetail,
  } = useRequest(() => getTemplateDetail(salesChannelUuid, category), {
    manual: true,
    onSuccess: (res) => {
      const {
        templates,
        templateSetting: {
          routingList,
          delayed,
          workingHours,
          workingHoursEnabled,
          channelSettings,
        } = {} as any,
      } = res || ({} as any);
      const delayedInstant = delayed === 0 ? true : false;
      const customizes = (workingHours || []).map((item) => ({
        range: [item.startTime, item.endTime],
        checked: item.enabled,
      }));
      const formChannelSettings = channelSettings.map((item) => {
        const templatesIndex = templates.filter(
          (o) => o.uuid === item.templateUuid,
        );
        const mpTemplatesIndex = (mpTemplates || []).filter(
          (o) => o.templateId === (item.mpTemplateSetting || {}).templateId,
        );

        return {
          ...item,
          templateUuid: templatesIndex[0],
          mpTemplateSetting: {
            mpTemplateId: mpTemplatesIndex[0],
            forAll: (item.mpTemplateSetting || {}).forAll,
            ...((item.mpTemplateSetting || {}).forAll === false
              ? {
                  languageContents: (
                    ((item || {}).mpTemplateSetting || {}).conditionContents ||
                    []
                  ).map((conditionContent) => ({
                    languages: conditionContent.languages,
                    setAsDefault: conditionContent.setAsDefault,
                    contents: (conditionContent.conditions || []).map(
                      (condition) => ({
                        content: {
                          params: condition.content.params.map(
                            (param) => param[1],
                          ),
                        },
                      }),
                    ),
                  })),
                }
              : {
                  languageContents: (
                    ((item || {}).mpTemplateSetting || {}).languageContents ||
                    []
                  ).map((languageContent) => ({
                    languages: languageContent.languages,
                    setAsDefault: languageContent.setAsDefault,
                    params: languageContent.params.map((param) => param[1]),
                  })),
                }),
          },
        };
      });
      const formRoutingList = (routingList || []).map((item, index) => {
        const templatesIndex = templates.filter(
          (o) => o.uuid === item.templateUuid,
        );
        return {
          ...item,
          templateUuid: templatesIndex[0],
        };
      });
      form.setFieldsValue({
        routingList: formRoutingList,
        delayedInstant,
        delayed,
        customizes,
        workingHoursEnabled,
        channelSettings: formChannelSettings,
      });
      setLoaded(true);
    },
  });

  const { run: _saveTemplate } = useRequest(
    (data) => saveTemplate(salesChannelUuid, data),
    {
      manual: true,
      onSuccess: (res) => {
        message.success(getI18n('general.savesuccess'));
        setHasModified(false);
      },
    },
  );

  const { run: _sendMessage } = useRequest((data) => sendMessage(data), {
    manual: true,
    onSuccess: (res) => {
      message.success(
        getI18n(
          'salesChannelCommunication.communicationCategory.sendsuccessfully',
        ),
      );
      onModalCancel();
    },
  });
  const areaCodesOptions = areaCodes.map((item) => ({
    ...item,
    label: `+ ${item.description}(${item.areaCode})`,
    areaCode: item.areaCode,
    value: item.uuid,
    uuid: item.uuid,
  }));

  const onGoBackClick = () => {
    history.push(`/salesChannel/setting/communication/${salesChannelUuid}`);
  };

  const onFinish = (values) => {
    values.category = category;

    values.workingHours = (values.customizes || []).map((item) => ({
      startTime: item.range[0],
      enabled: item.checked,
      endTime: item.range[1],
    }));

    values.delayed = values.delayedInstant === true ? 0 : values.delayed;
    values.channelSettings = values.channelSettings.map((item, index) => {
      const variables = get(item, 'mpTemplateSetting.mpTemplateId.variables');
      return {
        ...item,
        ...(get(channelSettings[index], 'channelType') ===
          CommunicationChannelType.WechatMP && {
          mpTemplateSetting: {
            forAll:
              get(item, 'mpTemplateSetting.forAll') === false ? false : true,
            templateId: get(item, 'mpTemplateSetting.mpTemplateId.templateId'),
            ...(get(item, 'mpTemplateSetting.forAll') === false
              ? {
                  conditionContents: (
                    (item.mpTemplateSetting || {}).languageContents || []
                  ).map((languageContent) => ({
                    ...languageContent,
                    channelType: get(channelSettings[index], 'channelType'),
                    conditions: (conditionsAll[category] || []).map(
                      (condition, cIndex) => ({
                        condition: condition.value,
                        content: {
                          templateId: get(
                            item,
                            'mpTemplateSetting.mpTemplateId.templateId',
                          ),
                          channelType: get(
                            channelSettings[index],
                            'channelType',
                          ),
                          params: languageContent.contents[
                            cIndex
                          ].content.params.map((param, index) => [
                            variables[index].code,
                            param,
                          ]),
                          setAsDefault: get(
                            channelSettings[index],
                            'setAsDefault',
                          ),
                        },
                      }),
                    ),
                  })),
                  languageContents: [],
                }
              : {
                  languageContents: (
                    (item.mpTemplateSetting || {}).languageContents || []
                  ).map((languageContent) => ({
                    ...languageContent,
                    templateId: get(
                      item,
                      'mpTemplateSetting.mpTemplateId.templateId',
                    ),
                    channelType: get(channelSettings[index], 'channelType'),
                    params: ((languageContent || {}).params || []).map(
                      (param, index) => [get(variables[index], 'code'), param],
                    ),
                  })),
                  conditionContents: [],
                }),
          },
        }),
        channelType: get(channelSettings[index], 'channelType'),
        templateUuid: get(
          values,
          `channelSettings[${index}].templateUuid.uuid`,
        ),
      };
    });
    values.routingList = (values.routingList || []).map((item, index) => ({
      ...item,
      templateUuid: get(values, `routingList[${index}].templateUuid.uuid`),
    }));
    _saveTemplate(values);
  };
  const onModalCancel = () => {
    setShowModal(false);
  };

  const onTestOkPress = (data, languageTag, templateUuid, channelType) => {
    _sendMessage({
      category,
      salesChannelCommunicationUuid: communicationUuid,
      templateUuid,
      ...(channelType === CommunicationChannelType.Email
        ? { emails: data }
        : { mobiles: data }),
      language: languageTag,
    });
  };

  const handleTest = (languageTag, templateUuid, channelType) => {
    setShowModal(true);
    setModalTitle(
      `${getI18n(
        'salesChannelCommunication.communicationCategory.sendTest',
      )} ${calculateTitle(channelType)}`,
    );
    setModalContent(
      <SendTestModal
        onCancel={onModalCancel}
        channelType={channelType}
        areaCodesOptions={areaCodesOptions}
        onOkPress={(data) =>
          onTestOkPress(data, languageTag, templateUuid, channelType)
        }
      />,
    );
  };
  const calculateTitle = (channelType) =>
    channelType === CommunicationChannelType.WhatsApp
      ? getI18n(
          'salesChannelCommunication.communicationCategory.whatsappMessage',
        )
      : channelType;

  return (
    <Spin spinning={breadCrumbLoading || dataLoading}>
      <CommonHeader
        breadcrumbData={breadcrumbData}
        onGoBackClick={onGoBackClick}
        onSaveDisable={!hasModified}
        onSubmit={() => form.submit()}
        onDiscard={onGoBackClick}
      />
      <Form
        onFinish={onFinish}
        name='salesChannelCommunicationTemplate'
        form={form}
        onValuesChange={() => {
          setHasModified(true);
        }}
        className={styles.commonContainer}>
        {loaded && (
          <OrderPaymentReminder
            timezoneGmt={timezoneGmt}
            periodUnit={periodUnit}
          />
        )}

        {channelSettings.map((item, index) => {
          return item.channelType === CommunicationChannelType.WechatMP ? (
            <MiniProgramSubscribeMessage
              templates={mpTemplates}
              key={item.channelType}
              languages={languages}
              dataIndex={index}
              form={form}
            />
          ) : (
            <div key={item.channelType}>
              <CommonTemplate
                templates={templates}
                channelType={item.channelType}
                category={category}
                dataIndex={index}
                title={calculateTitle(item.channelType)}
                onSendTest={(languageTag, templateUuid) =>
                  handleTest(languageTag, templateUuid, item.channelType)
                }
              />
              {item.channelType === CommunicationChannelType.SMS && (
                <SMSLocalisedRouting
                  templates={templates}
                  channelType={item.channelType}
                  form={form}
                  category={category}
                  areaCodesOptions={areaCodesOptions}
                  onSendTest={(languageTag, templateUuid) =>
                    handleTest(languageTag, templateUuid, item.channelType)
                  }
                />
              )}
            </div>
          );
        })}
      </Form>
    </Spin>
  );
};

export default ModalHOC(Template);
